export const PLUGINS_DRAWER_ROLE = 'plugins-drawer';
export const CLOSE_PLUGINS_DRAWER_BUTTON_ROLE = 'close-plugins-drawer-drawer-button';
